<script>
	import { cuenta } from './../controlador/store.js';
    import { onMount } from 'svelte';
import { push } from 'svelte-spa-router';
    //import marked from 'marked';
    export let item;
    let fecha = '';
    let hora = '';
    let data;
    let width;
    let href = `https://wa.me/?text=La receta Actual es : https://receta-online.onrender.com/#/${item._id}`;
    let hrefTel = `whatsapp://send?text=La receta Actual es : https://receta-online.onrender.com/#/${item._id}`;
    onMount(()=>{
        let date = new Date();
        fecha = `${date.getDate()}/${date.getMonth()+1}/${date.getFullYear()}`;
        hora = `${date.getHours()}:${(date.getMinutes()<9? `0${date.getMinutes()}`:date.getMinutes())}`;
        data = marked(item.cuerpo);
        href = `https://wa.me/?text=La receta Actual es : https://receta-online.onrender.com/#/${item._id}`;
        hrefTel = `whatsapp://send?text=La receta Actual es : https://receta-online.onrender.com/#/${item._id}`;
    })

    function generar(){
        //push(`/ver/receta/${item._id}`);
        console.log(href);
        window.open((width > 450? href : hrefTel));
    }
</script>
<svelte:window bind:innerWidth={width}/>
<div class="carta" on:click={generar}>
    <div class="fila">
        <div class="nombre">
            <span>{$cuenta.nombre}</span>
        </div>
        <div class="titulo">
            <span>{$cuenta.titulo}</span>
            <span>{$cuenta.matricula}</span>
        </div>
    </div>
    <div class="fila">
        <div class="datos">
            <div class="col"><span>Nombre: </span>{item.nombre}</div>
            <div class="col"><span>Documento: </span>{item.documento}</div>
        </div>
        <div class="datos">
            <div class="col"><span>Mutual: </span>{item.mutual}</div>
            <div class="col"><span>N° Afiliado: </span>{item.afiliado}</div>
        </div>
    </div>
    <div class="cuerpo">
        <span>RP/ </span>
        <div class="output">{@html data}</div>
    </div>
    <div class="pie">
        <div class="horafecha">
            {fecha} - {hora}Hs.
        </div>
        <div class="firma">
            <img src={item.firma} alt="f">
            <span>{$cuenta.nombre} - {$cuenta.titulo} - {$cuenta.matricula}</span>
        </div>
    </div>
</div>

<style>
	.carta{
        width: 90%;
        max-width: 380px;
        height: 380px;
        background: linear-gradient(135deg, rgba(255,255,255,1) 0%, rgba(207,215,255,1) 100%);
        color: var(--negro);
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding: 5px;
        font-size: 12px;
    }
    .nombre{
        width: 50%;
        border-bottom: solid 1px rgba(0,0,0,.1);
        display: flex;
        align-items: center;
        justify-content: center;
        height:50px;
    }
    .titulo{
        width: 50%;
        border-bottom: solid 1px rgba(0,0,0,.1);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height:50px;
    }
    span{
        font-weight: bold;
    }
    .datos{
        width: 50%;
        height: 100%;
        border-bottom: solid 1px rgba(0,0,0,.1);
    }
    .fila{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
    .cuerpo{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        width: 100%;
        height: 250px;
        padding: 5px;
    }
    .pie{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100px;
    }
    .pie > .firma{
        display: flex;
        align-content: center;
        justify-content: center;
        position: relative;
        width: 50%;
        height: 100px;
    }
    .pie > .horafecha{
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .pie > .firma > img {
        width: 100px;
        object-fit: cover;
    }
    .pie > .firma > span{
        border-top: solid 1px rba(0,0,0,.1);
        position: absolute;
        bottom: 0;
        left: 0;
    }
</style>